<template>
    <div>
        <div class="d-flex" id="wrapper">
            <!-- Sidebar -->
            <SideBar />
            <!-- /#sidebar-wrapper -->
            <!-- Page Content -->
            <div id="page-content-wrapper">
                <nav style="justify-content:flex-start;" class="navbar navbar-expand-lg navbar-light bg-light border-bottom floating">
                    <div>
                        <button class="btn btn-outline" id="menu-toggle" @click="sidebar"><span class="navbar-toggler-icon"></span>
                        </button>

                        <button style="color: rgba(0,0,0,.5);border-color: rgba(0,0,0,.1);" class="btn btn-outline navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                            <span style="padding-top:0.5em;"><i class="fas fa-user-alt"></i><span class="account-div"></span><i class="fas fa-angle-down"></i></span>
                        </button>
                    </div>
                    <div class="d-flex">
                        <!-- <i class="fas fa-home text-muted hover-cursor" @click="toPage('/dashboard')"></i> -->
                        <p class="text-muted mb-0 hover-cursor link" @click="toProductCatalogPage">&nbsp;Product</p>
                        <p class="text-primary mb-0 hover-cursor">&nbsp;/&nbsp;{{pageAction}} Bundling Product</p>
                    </div>
                    <div class="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul class="navbar-nav ml-auto mt-2 mt-lg-0">
                            <li class="nav-item dropdown">
                                <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    {{ admin }}
                                </a>
                                <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
                                    <a class="dropdown-item link" @click="toPage('/password')"> <i class="fas fa-cog"></i><span class="right-dropdown">Change Password</span></a>
                                    <a class="dropdown-item link" @click="handleLogout"><i class="fas fa-sign-out-alt"></i><span class="right-dropdown">Logout</span></a>
                                </div>
                            </li>
                        </ul>
                    </div>
                </nav>
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-md-12 grid-margin stretch-card card-div">
                            <div class="container">
                                <div class="d-flex justify-content-between mb-5 mt-4">
                                    <div></div>
                                    <h5 class="m-auto">{{pageAction}} Bundling Product</h5>
                                    <button class="btn btn-primary" @click="openModal('Log')">Show Log</button>
                                </div>
                                <div class="d-flex flex-wrap justify-content-between">
                                    <div class="card w-100 mt-4" v-for="(input, index) in productChoose" :key="`productChoose-${index}`">
                                        <div class="card-body">
                                            <span class="ol-label" style="font-weight: bold;">Product #{{productChoose[index]}}</span>
                                            <div class="row">
                                                <div class="col-6">
                                                    <div class="w-100 d-flex align-items-center">
                                                        <span class="field-label"> Type </span>
                                                        <multiselect
                                                            v-model="addType"
                                                            :options="productType"
                                                            label="productTypeName"
                                                            :allow-empty="false"
                                                            :select-label="'Type'"
                                                            deselect-label="Can't remove this value"
                                                            placeholder="Product Type"
                                                        ></multiselect>
                                                    </div>
                                                </div>
                                                <div class="col-6">
                                                    <div class="w-100 d-flex align-items-center">
                                                        <span class="field-label"> Name </span>
                                                        <input type="text" name="product" class="form-control" v-model="newBrand" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="d-flex align-items-center mt-2">
                                                <span class="field-label-one select"> Specifications </span>
                                                <multiselect
                                                    v-model="conditionProduct[index]"
                                                    :options="productCondition"
                                                    label="statusName"
                                                    :allow-empty="false"
                                                    :select-label="''"
                                                    :deselect-label="''"
                                                    placeholder="Condition"
                                                    track-by="statusName"
                                                    @input="updateDuration('condition',index)"
                                                ></multiselect>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="d-flex justify-content-end mt-2">
                                    <button class="btn btn-primary" @click="addRowProduct(productChoose.length)">More Product</button>
                                </div>
                                <div class="row mt-5">
                                    <div class="col-6">
                                        <div class="d-flex align-items-center mb-2">
                                            <span class="field-label-one select"> Category </span>
                                            <multiselect
                                                v-model="addCategory"
                                                :options="productCategory"
                                                label="productCategory"
                                                :allow-empty="false"
                                                :select-label="'Category'"
                                                deselect-label="Can't remove this value"
                                                placeholder="Product Category"
                                            ></multiselect>
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div class="w-100 d-flex align-items-center">
                                            <span class="field-label"> Name </span>
                                            <input type="text" name="product" class="form-control" v-model="newBrand" />
                                        </div>
                                    </div>
                                </div>
                                <div class="mt-3">
                                    <span class="ol-label">Pictures</span>
                                    <div class="d-flex flex-wrap justify-content-between">
                                        <div class="one-file text-center">
                                            <img src="https://asani-imagestorage.s3-ap-southeast-1.amazonaws.com/logo_upload+product/template_product.jpg" class="img-responsive" id="show_img_1" />
                                            <div class="one-line-file text-center">
                                                <input type="file" name="" class="form-control-file form-control-sm" id="file_img_1" @change="onFilePicked($event,1)" ref="input_img_1" hidden />
                                                <div class="d-flex">
                                                    <button class="btn btn-primary btn-sm mr-2 mt-2 w-100" @click="pickFile('input_img_1')">Browse</button>
                                                    <button class="btn btn-danger btn-sm mt-2 w-100" @click="removeImage(1)">Remove</button>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="one-file text-center">
                                            <img src="https://asani-imagestorage.s3-ap-southeast-1.amazonaws.com/logo_upload+product/template_product.jpg" class="img-responsive" id="show_img_2" />
                                            <div class="one-line-file">
                                                <input type="file" name="" class="form-control-file form-control-sm" id="file_img_2" @change="onFilePicked($event,2)" ref="input_img_2" hidden />
                                                <div class="d-flex">
                                                    <button class="btn btn-primary btn-sm mr-2 mt-2 w-100" @click="pickFile('input_img_2')">Browse</button>
                                                    <button class="btn btn-danger btn-sm mt-2 w-100" @click="removeImage(2)">Remove</button>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="one-file text-center">
                                            <img src="https://asani-imagestorage.s3-ap-southeast-1.amazonaws.com/logo_upload+product/template_product.jpg" class="img-responsive" id="show_img_3" />
                                            <div class="one-line-file">
                                                <input type="file" name="" class="form-control-file form-control-sm" id="file_img_3" @change="onFilePicked($event,3)" ref="input_img_3" hidden />
                                                <div class="d-flex">
                                                    <button class="btn btn-primary btn-sm mr-2 mt-2 w-100" @click="pickFile('input_img_3')">Browse</button>
                                                    <button class="btn btn-danger btn-sm mt-2 w-100" @click="removeImage(3)">Remove</button>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="one-file text-center">
                                            <img src="https://asani-imagestorage.s3-ap-southeast-1.amazonaws.com/logo_upload+product/template_product.jpg" class="img-responsive" id="show_img_4" />
                                            <div class="one-line-file">
                                                <input type="file" name="" class="form-control-file form-control-sm" id="file_img_4" @change="onFilePicked($event,4)" ref="input_img_4" hidden />
                                                <div class="d-flex">
                                                    <button class="btn btn-primary btn-sm mr-2 mt-2 w-100" @click="pickFile('input_img_4')">Browse</button>
                                                    <button class="btn btn-danger btn-sm mt-2 w-100" @click="removeImage(4)">Remove</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="mt-3">
                                    <label class="ol-label"> Description </label>
                                    <div>
                                        <textarea class="form-control form-control-sm" rows="5" id="description" v-model="addDescription" style="resize: none;"></textarea>
                                    </div>
                                </div>
                                <div class="d-flex flex-wrap mt-3 justify-content-between">
                                    <div class="card w-49 mt-4" v-for="(input, index) in tenor" :key="`tenor-${index}`">
                                        <div class="card-body">
                                            <span class="ol-label" style="font-weight: bold;">Tenor #{{tenor[index]}}</span>
                                            <div class="d-flex align-items-center">
                                                <span class="field-label"> Tenor </span>
                                                <multiselect
                                                    v-model="addDuration[index]"
                                                    :options="productDuration[0]"
                                                    :allow-empty="false"
                                                    :select-label="'Month'"
                                                    deselect-label=""
                                                    placeholder="Duration"
                                                    @input="updateDuration('duration',index)"
                                                ></multiselect>
                                                <span class="ml-2">month</span>
                                            </div>
                                            <div class="one-line mt-2" v-if="addDuration[index] == 'Other'">
                                                <label class="field-label new-tenor"> New Tenor </label>
                                                <input type="text" name="duration" class="form-control" v-model="newDuration[index]" @keypress="isNumber($event)" />
                                                <span class="ml-2 mt-auto mb-auto">month</span>
                                            </div>
                                            <div class="d-flex align-items-center mt-2">
                                                <span class="field-label"> Rent Fee </span>
                                                <div class="input-group">
                                                    <span class="input-group-addon" style="margin-left: 0px;"> <label class="label-addon-rp">Rp</label></span>
                                                    <input type="text" class="form-control" name="price" @keypress="isNumber($event)" v-model="durationPrice[index]" />
                                                </div>
                                                <span class="ml-2">month</span>
                                            </div>
                                            <div class="d-flex align-items-center mt-2">
                                                <span class="field-label-one"> Condition </span>
                                                <multiselect
                                                    v-model="conditionProduct[index]"
                                                    :options="productCondition"
                                                    label="statusName"
                                                    :allow-empty="false"
                                                    :select-label="''"
                                                    :deselect-label="''"
                                                    placeholder="Condition"
                                                    track-by="statusName"
                                                    @input="updateDuration('condition',index)"
                                                ></multiselect>
                                            </div>
                                            <div class="d-flex align-items-center mt-2">
                                                <span class="field-label-one"> Status </span>
                                                <multiselect
                                                    v-model="statusProduct[index]"
                                                    :options="productStatus"
                                                    label="statusName"
                                                    :allow-empty="false"
                                                    :select-label="''"
                                                    :deselect-label="''"
                                                    placeholder="Status"
                                                    track-by="statusName"
                                                ></multiselect>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="d-flex mt-4 justify-content-end">
                                    <div>
                                        <button class="btn btn-danger btn-sm" @click="toProductCatalogPage">Cancel</button>
                                        <button class="btn btn-success btn-sm" @click="addRow(tenor.length)">Add Tenor</button>
                                        <button class="btn btn-primary btn-sm" @click="validationField('Save')">Save</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- /#page-content-wrapper -->
            <!-- Modal Save-->
            <div class="modal fade" id="modalSave" role="dialog">
                <div class="modal-dialog modal-dialog-centered">
                    <!-- Modal content-->
                    <div class="modal-content">
                        <div class="modal-header">
                            <div class="change-title">
                                <h4 class="modal-title">Save Product</h4>
                            </div>
                            <button type="button" class="close" data-dismiss="modal">&times;</button>
                        </div>
                        <div class="modal-body">
                            <p>Are you sure to save product {{ addModel }} ?</p>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal">Cancel</button>
                            <button type="button" class="btn btn-primary btn-sm" v-if="loadingButtonProcess == false" @click="submitAddProduct('draft')">Save</button>
                            <button type="button" class="btn btn-primary btn-sm" disabled v-else><img src="~@/assets/images/2.gif" style="height: 18px;" />Save</button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- endModal -->
            <div class="modal fade" id="modalLog" role="dialog">
                <div class="modal-dialog modal-dialog-centered modal-xl">
                    <!-- Modal content-->
                    <div class="modal-content">
                        <div class="modal-header">
                            <div class="change-title">
                                <h4 class="modal-title">Product Name Log</h4>
                            </div>
                            <button type="button" class="close" data-dismiss="modal">&times;</button>
                        </div>
                        <div class="modal-body">
                            <table class="table table-sm table-bordered table-striped table-responsive-sm">
                                <thead class="">
                                    <tr>
                                        <th>Date</th>
                                        <th>Action</th>
                                        <th>Executor</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="loadingLog === false && totalData == '0'">
                                        <td colspan="3" class="text-center">Data Not Available</td>
                                    </tr>
                                    <tr v-else-if="loadingLog === true">
                                        <td colspan="3" class="text-center"><img src="~@/assets/images/load-button.gif" /></td>
                                    </tr>
                                    <tr v-for="(data,index) in dataLog" :key="`log-${index}`" v-else>
                                        <td>1</td>
                                        <td>2</td>
                                        <td>3</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import swal from 'sweetalert'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import SideBar from '../SideBar'
export default {
    name: 'ProductAddPage',
    components: {
        SideBar,
        Multiselect
    },
    data() {
        return {
            spaceRegex: /[\u00A0\uFEFF\u202F]/g,
            admin: "",
            permission: [],
            viewDashboard: false,
            viewOrder: false,
            viewReturn: false,
            viewProduct: false,
            viewPairing: false,
            viewReconcile: false,
            viewResolution: false,
            viewLessor: false,
            viewLessee: false,
            viewEmployee: false,
            editOrder: false,
            editReturn: false,
            editProduct: false,
            editPairing: false,
            editReconcile: false,
            editResolution: false,
            editLessor: false,
            editLessee: false,
            editEmployee: false,
            loadingButtonProcess: false,
            loadingLog:false,
            dataOrder: [],
            totalPage: 0,
            totalData: 0,
            currentPage: 1,
            orderId: "",
            companyName: "",
            statusOrder: "",
            productCategory: [],
            productType: [],
            productBrand: [],
            addCategory: [],
            productDuration: [[]],
            productDisplayType: ['LCD', 'LED'],
            productVGA: ['Tersedia', 'Tidak Ada'],
            productDVID: ['Tersedia', 'Tidak Ada'],
            productHDMI: ['Tersedia', 'Tidak Ada'],

            addType: [],
            addBrand: '',
            addModel: '',
            addScreen: '',
            addProcessor: '',
            addRam: '',
            addStorage: [],
            addStorageSmartphone: [],
            addVGA: '',
            mainCamera: '',
            frontCamera: '',

            addDisplaySize: '',
            addDisplayType: '',
            addPortVga: '',
            addPortDvid: '',
            addPortHdmi: '',
            addColorTech: '',
            AddFeature: '',
            addBattery:'',

            addSpecifications:'',
            addDescription: '',
            addDuration: [''],
            newDuration: [''],
            durationPrice: [''],
            newDurationPrice: [''],
            depositPrice: [''],
            insurancePrice: [''],
            addPhoto: [],
            imgFile: '',
            imgFileName: '',
            imgBase64: '',
            imgUrl: '',
            newBrand: '',
            storageType: 'SSD',
            storageTypeSmartphone: 'EMMC',
            tenor: [1],
            plusIdx: 0,
            duration: [],
            newCategory: '',
            durationValue:[],
            conditionProduct:[{
                status:'1',
                statusName:'New'
            }],
            productCondition:[{
                status:'1',
                statusName:'New'
            },{
                status:'2',
                statusName:'Refurbished'
            }],
            temp:[],
            statusProduct:[{
                status:'1',
                statusName:'Active'
            }],
            productStatus:[{
                status:'1',
                statusName:'Active'
            },{
                status:'0',
                statusName:'Inactive'
            }],
            productChoose:[1],
            dataLog:[1],
            pageAction:''
        }
    },
    methods: {
        pickFile(ref){
            this.$refs[ref].click()
        },
        toProductCatalogPage(){
          this.$router.push({path:'/product',
                query: {
                    productType: 'All',
                    productTypeName: 'All',
                    productCategory: 'All',
                    productBrand: 'All',
                    productStatus: 'All',
                    productStatusName: 'All',
                    productName: '',
                    itemPerPage: 10,
                    page:1
                }
            })
        },
        updateDuration(pilih,index){
            if (pilih == 'condition') {
                for (var i = 0; i < this.conditionProduct.length; i++) {
                    if (i!=index) {
                       if (this.conditionProduct[index].status == this.conditionProduct[i].status && this.addDuration[index] == this.addDuration[i]) {
                            this.addDuration[index]=''
                       } 
                    } 
                }
            }
            for (var i = 0; i < this.conditionProduct.length; i++) {
                this.productDuration[i]=[]
                var arrayNew = []
                var arrayRef = []
                for (var k = 0; k < this.temp.length; k++) {
                    arrayNew.push(this.temp[k])
                    arrayRef.push(this.temp[k])
                }
                
                for (var j = 0; j < this.conditionProduct.length; j++) {
                    if (i!=j) {
                        if (this.addDuration[j] != 'Other') {
                            if (this.conditionProduct[i].status == 1) {
                                if (this.conditionProduct[i].status == this.conditionProduct[j].status) {
                                    var index = arrayNew.indexOf(this.addDuration[j]);
                                    if (index !== -1) arrayNew.splice(index, 1);
                                }
                            }else{
                                if (this.conditionProduct[i].status == this.conditionProduct[j].status) {
                                    var index = arrayRef.indexOf(this.addDuration[j]);
                                    if (index !== -1) arrayRef.splice(index, 1);
                                }
                            }
                        }
                    }
                }
                if (this.conditionProduct[i].status == 1) {
                    for (var l = 0; l < arrayNew.length; l++) {
                        this.productDuration[i].push(arrayNew[l])
                    }
                }else{
                    for (var l = 0; l < arrayRef.length; l++) {
                        this.productDuration[i].push(arrayRef[l])
                    }
                }               
            }
        },
        addRowProduct(count) {
            this.productChoose.push(count+1)    
        },
        addRow(x) {
                if (this.cekDuration() == 0) {
                    this.plusIdx = this.plusIdx + 1
                    this.addDuration.push('')

                    this.durationPrice.push('')
                    this.newDuration.push('')
                    this.newDurationPrice.push('')
                    this.depositPrice.push('')
                    this.insurancePrice.push('')
                    this.tenor.push(x+1)
                    this.conditionProduct.push({
                        status:'1',
                        statusName:'New'
                    })
                    this.statusProduct.push({
                        status:'1',
                        statusName:'Active'
                    })
                    this.updateDuration()
                }
            },
            validationField(x) {
                if (this.addType == null || this.addType == '') {
                    swal("Sorry", "Product type must be select", "error", {
                        button: "Ok",
                    })
                } else if (this.cekCategory() != 0) {
                    swal("Sorry", "Product Category must be fill", "error", {
                        button: "Ok",
                    })
                } else if (this.addBrand == '') {
                    swal("Sorry", "Product Brand must be select", "error", {
                        button: "Ok",
                    })
                } else if (this.addBrand == 'Other') {
                    if (this.newBrand == '') {
                        swal("Sorry", "New Brand must be fill", "error", {
                            button: "Ok",
                        })
                    } else if (this.cekBottomofBrand(this.addType.productType) != 0) {

                    } else if (this.cekDuration() != 0) {
                        swal("Sorry", "Product Duration or price or deposit must be fill", "error", {
                            button: "Ok",
                        })
                    } else {
                        this.openModal(x)
                    }
                } else if (this.cekBottomofBrand(this.addType.productType) != 0) {

                } else if (this.cekDuration() != 0) {
                    swal("Sorry", "Product Duration or price or deposit must be fill", "error", {
                        button: "Ok",
                    })
                } else {
                    this.openModal(x)
                }
            },
            cekCategory: function() {
                var kosong = 0
                if (this.addType.productType<7) {
                    if (this.addCategory.productCategory == '' || this.addCategory.productCategory == null) {
                        kosong = kosong + 1
                    } else if (this.addCategory.productCategory == 'Other') {
                        if (this.newCategory == '') {
                            kosong = kosong + 1
                        }
                    }  
                }
                return kosong
            },
            cekDuration: function() {
                var kosong = 0
                for (var i = 0; i < this.addDuration.length; i++) {
                    if (this.addDuration[i] != 'Other' && (this.addDuration[i] == '' || this.durationPrice[i] == '' || this.durationPrice[i] == '0' || this.depositPrice[i] == '' || this.insurancePrice[i] == '')) {
                        kosong = kosong + 1
                    } else if (this.addDuration[i] == 'Other') {
                        if (this.newDuration[i] == '' || this.newDuration[i] == '0' || this.newDurationPrice[i] == '' || this.newDurationPrice[i] == '0' || this.depositPrice[i] == '' || this.insurancePrice[i] == '') {
                            kosong = kosong + 1
                        }
                    }
                }
                return kosong
            },
            cekBottomofBrand: function(type) {
                var salah = 0
                if (type == 1 || type == 2) {
                    if (this.addModel == '') {
                        swal("Sorry", "Product Model must be fill", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    } else if (this.addScreen == '') {
                        swal("Sorry", "Product Screen must be fill", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    } else if (this.addProcessor == '') {
                        swal("Sorry", "Product Processor must be fill", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    } else if (this.addRam == '') {
                        swal("Sorry", "Product RAM must be fill", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    } else if (this.storageType == 'HDD+SSD') {
                        if (this.addStorage[0] == '' || this.addStorage[0] == null) {
                            swal("Sorry", "Product Storage must be fill", "error", {
                                button: "Ok",
                            })
                            salah = salah + 1
                        }else if (this.addStorage[1] == '' || this.addStorage[1] == null) {
                            swal("Sorry", "Product Storage must be fill", "error", {
                                button: "Ok",
                            })
                            salah = salah + 1
                        }else if (this.addVGA == '') {
                            swal("Sorry", "Product VGA must be fill", "error", {
                                button: "Ok",
                            })
                            salah = salah + 1
                        } else if (this.cekFoto() == 6) {
                            swal("Sorry", "Product Foto minimum 1", "error", {
                                button: "Ok",
                            })
                            salah = salah + 1
                        }
                    } else if (this.addStorage == '') {
                        swal("Sorry", "Product Storage must be fill", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    } else if (this.addVGA == '') {
                        swal("Sorry", "Product VGA must be fill", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    } else if (this.cekFoto() == 6) {
                        swal("Sorry", "Product Foto minimum 1", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    }
                }else if (type == 5 || type == 6) {
                    if (this.addModel == '') {
                        swal("Sorry", "Product Model must be fill", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    } else if (this.addScreen == '' || this.addScreen == null) {
                        swal("Sorry", "Product Screen must be fill", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    } else if (this.addProcessor == '' || this.addProcessor == null ) {
                        swal("Sorry", "Product Processor must be fill", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    } else if (this.addRam == '') {
                        swal("Sorry", "Product RAM must be fill", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    } else if (this.addStorageSmartphone == '') {
                        swal("Sorry", "Product Storage must be fill", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    } else if (this.addBattery == '') {
                        swal("Sorry", "Product Battery must be fill", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    }else if (this.AddFeature == '') {
                        swal("Sorry", "Product Feature must be fill", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    } else if (this.cekFoto() == 6) {
                        swal("Sorry", "Product Foto minimum 1", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    }
                } else if (type == 3) {
                    if (this.addModel == '') {
                        swal("Sorry", "Product Model must be fill", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    } else if (this.addDisplaySize == '') {
                        swal("Sorry", "Display Size must be fill", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    } else if (this.addDisplayType == '') {
                        swal("Sorry", "Display Type must be fill", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    } else if (this.addPortVga == '') {
                        swal("Sorry", "Port VGA must be fill", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    } else if (this.addPortDvid == '') {
                        swal("Sorry", "Port DVI-D must be fill", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    } else if (this.addPortHdmi == '') {
                        swal("Sorry", "Port HDMI must be fill", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    } else if (this.cekFoto() == 6) {
                        swal("Sorry", "Product Foto minimum 1", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    }
                } else if (type == 4) {
                    if (this.addModel == '') {
                        swal("Sorry", "Product Model must be fill", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    } else if (this.addColorTech == '') {
                        swal("Sorry", "Color Technology must be fill", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    } else if (this.AddFeature == '') {
                        swal("Sorry", "Feature must be fill", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    } else if (this.cekFoto() == 6) {
                        swal("Sorry", "Product Foto minimum 1", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    }
                } else {
                    if (this.addModel == '') {
                        swal("Sorry", "Product Model must be fill", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    } else if (this.addScreen == '' && this.addType.productType < 7) {
                        swal("Sorry", "Product Screen must be fill", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    }else if (this.addSpecifications == '' && this.addType.productType > 6) {
                        swal("Sorry", "Product specifications must be fill", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    } else if (this.cekFoto() == 6) {
                        swal("Sorry", "Product Foto minimum 1", "error", {
                            button: "Ok",
                        })
                        salah = salah + 1
                    }
                }
                return salah
            },
            cekFoto: function() {
                var kosong = 6
                for (var i = 0; i < 6; i++) {
                    if (this.addPhoto[i].imgFileName != '') {
                        kosong = kosong - 1
                    }
                }
                return kosong
            },
            submitAddProduct(x) {
                var self = this
                this.loadingButtonProcess = true
                if (this.addBrand == 'Other') {
                    this.addBrand = this.newBrand
                }
                if (this.addCategory.productCategory == 'Other') {
                    this.addCategory.productCategory = this.newCategory
                }
                for (var i = 0; i < this.addDuration.length; i++) {
                    if (this.addDuration[i] == 'Other') {
                        this.durationValue[i] = this.newDuration[i]
                        this.durationPrice[i] = this.newDurationPrice[i]
                    } else {
                        this.durationValue[i] = this.addDuration[i]
                    }
                }
                if (this.addType.productType == 1 || this.addType.productType == 2) {
                    var storage
                    if (this.storageType == 'HDD+SSD') {
                        storage = this.addStorage[0] +'GB HDD , ' + this.addStorage[1] +'GB SSD'
                    }else{
                        storage = this.addStorage[0] + 'GB ' + this.storageType
                    }
                    var details = {
                        brand: this.addBrand !== null ? this.addBrand.replace(this.spaceRegex, ' ') : this.addBrand,
                        model: this.addModel !== null ? this.addModel.replace(this.spaceRegex, ' ') : this.addModel,
                        screen: this.addScreen.toString().replace(this.spaceRegex, ' '),
                        processor: this.addProcessor !== null ? this.addProcessor.replace(this.spaceRegex, ' ') : this.addProcessor,
                        ram: this.addRam !== null ? this.addRam.toString().replace(this.spaceRegex, ' ') : this.addRam,
                        storage: storage,
                        vga: this.addVGA !== null ? this.addVGA.replace(this.spaceRegex, ' ') : this.addVGA
                    }
                    for (var i = 0; i < this.addDuration.length; i++) {
                        this.duration.push({
                            tenorMonths: this.durationValue[i],
                            price: this.durationPrice[i],
                            depositPrice: this.depositPrice[i],
                            insurancePrice: this.insurancePrice[i],
                            condition:this.conditionProduct[i].status
                        })
                    }
                    this.$http.post(process.env.ADD_PRODUCT, {
                            productType: this.addType.productType,
                            productCategory: this.addCategory.productCategory,
                            details: details,
                            description: this.addDescription !== null ? this.addDescription.replace(this.spaceRegex, ' ') : this.addDescription,
                            photo: this.addPhoto,
                            duration: this.duration,
                            adminId: this.adminId,
                            status: x
                        }, {
                            timeout: 30 * 1000,
                            headers: {
                                'Asani-Token': localStorage.getItem('jwt')
                            }
                        })
                        .then(response => {
                            if (response.data.status == 400) {
                                swal("Sorry", response.data.message, "error", {
                                    button: "Ok",
                                })
                            } else if (response.data.status == 200) {
                                swal("Success", response.data.message, "success", {
                                    button: "Ok",
                                })
                                if (x == 'publish') {
                                    $('#modalSavePublish').modal('hide')
                                } else {
                                    $('#modalSaveDraft').modal('hide')
                                }
                                this.sendLog(response.data.content)
                                this.toProductCatalogPage()
                                this.loadingButtonProcess = false
                            }else if (response.data.status == 201) {
                                swal("Failed", response.data.message, "error", {
                                    button: "Close",
                                })
                                if (x == 'publish') {
                                    $('#modalSavePublish').modal('hide')
                                } else {
                                    $('#modalSaveDraft').modal('hide')
                                }
                                this.duration=[]
                                this.loadingButtonProcess = false
                            }
                        })
                        .catch(error => {
                            alert('Request timeout / error with api, please try again!')
                            self.loadingButtonProcess = false
                            swal("Sorry", error.response.data.message, "error", {
                                button: "Ok",
                            }).then(v => {
                                if(error.response.data.status == 401) {
                                    this.handleLogout()
                                }
                            })
                        })
                } else if (this.addType.productType == 3) {
                    var details = {
                        brand: this.addBrand !== null ? this.addBrand.replace(this.spaceRegex, ' ') : this.addBrand,
                        model: this.addModel !== null ? this.addModel.replace(this.spaceRegex, ' ') : this.addModel,
                        displaySize: this.addDisplaySize.toString().replace(this.spaceRegex, ' '),
                        displayType: this.addDisplayType !== null ? this.addDisplayType.replace(this.spaceRegex, ' ') : this.addDisplayType,
                        portVga: this.addPortVga,
                        portDvid: this.addPortDvid,
                        portHdmi: this.addPortHdmi
                    }
                    for (var i = 0; i < this.addDuration.length; i++) {
                        this.duration.push({
                            tenorMonths: this.durationValue[i],
                            price: this.durationPrice[i],
                            depositPrice: this.depositPrice[i],
                            insurancePrice: this.insurancePrice[i],
                            condition:this.conditionProduct[i].status
                        })
                    }
                    this.$http.post(process.env.ADD_PRODUCT, {
                            productType: this.addType.productType,
                            productCategory: this.addCategory.productCategory,
                            details: details,
                            description: this.addDescription !== null ? this.addDescription.replace(this.spaceRegex, ' ') : this.addDescription,
                            photo: this.addPhoto,
                            duration: this.duration,
                            adminId: this.adminId,
                            status: x
                        }, {
                            timeout: 30 * 1000,
                            headers: {
                                'Asani-Token': localStorage.getItem('jwt')
                            }
                        })
                        .then(response => {
                            if (response.data.status == 400) {
                                swal("Sorry", response.data.message, "error", {
                                    button: "Ok",
                                })
                            } else if (response.data.status == 200) {
                                swal("Success", response.data.message, "success", {
                                    button: "Ok",
                                })
                                if (x == 'publish') {
                                    $('#modalSavePublish').modal('hide')
                                } else {
                                    $('#modalSaveDraft').modal('hide')
                                }
                                this.sendLog(response.data.content)
                                this.toProductCatalogPage()
                                this.loadingButtonProcess = false
                            }else if (response.data.status == 201) {
                                swal("Failed", response.data.message, "error", {
                                    button: "Close",
                                })
                                if (x == 'publish') {
                                    $('#modalSavePublish').modal('hide')
                                } else {
                                    $('#modalSaveDraft').modal('hide')
                                }
                                this.duration=[]
                                this.loadingButtonProcess = false
                            }
                        })
                        .catch(error => {
                            alert('Request timeout / error with api, please try again!')
                            self.loadingButtonProcess = false
                            swal("Sorry", error.response.data.message, "error", {
                                button: "Ok",
                            }).then(v => {
                                if(error.response.data.status == 401) {
                                this.handleLogout()
                                }
                            })
                        })
                } else if (this.addType.productType == 4) {
                    var details = {
                        brand: this.addBrand,
                        model: this.addModel,
                        colorTech: this.addColorTech,
                        feature: this.AddFeature
                    }
                    for (var i = 0; i < this.addDuration.length; i++) {
                        this.duration.push({
                            tenorMonths: this.durationValue[i],
                            price: this.durationPrice[i],
                            depositPrice: this.depositPrice[i],
                            insurancePrice: this.insurancePrice[i],
                            condition:this.conditionProduct[i].status
                        })
                    }
                    this.$http.post(process.env.ADD_PRODUCT, {
                            productType: this.addType.productType,
                            productCategory: this.addCategory.productCategory,
                            details: details,
                            description: this.addDescription !== null ? this.addDescription.replace(this.spaceRegex, ' ') : this.addDescription,
                            photo: this.addPhoto,
                            duration: this.duration,
                            adminId: this.adminId,
                            status: x
                        }, {
                            timeout: 30 * 1000,
                            headers: {
                                'Asani-Token': localStorage.getItem('jwt')
                            }
                        })
                        .then(response => {
                            if (response.data.status == 400) {
                                swal("Sorry", response.data.message, "error", {
                                    button: "Ok",
                                })
                            } else if (response.data.status == 200) {
                                swal("Success", response.data.message, "success", {
                                    button: "Ok",
                                })
                                if (x == 'publish') {
                                    $('#modalSavePublish').modal('hide')
                                } else {
                                    $('#modalSaveDraft').modal('hide')
                                }
                                this.sendLog(response.data.content)
                                this.toProductCatalogPage()
                                this.loadingButtonProcess = false
                            }else if (response.data.status == 201) {
                                swal("Failed", response.data.message, "error", {
                                    button: "Close",
                                })
                                if (x == 'publish') {
                                    $('#modalSavePublish').modal('hide')
                                } else {
                                    $('#modalSaveDraft').modal('hide')
                                }
                                this.duration=[]
                                this.loadingButtonProcess = false
                            }
                        })
                        .catch(error => {
                            alert('Request timeout / error with api, please try again!')
                            self.loadingButtonProcess = false
                            swal("Sorry", error.response.data.message, "error", {
                                button: "Ok",
                            }).then(v => {
                                if(error.response.data.status == 401) {
                                    this.handleLogout()
                                }
                            })
                        })
                } else if (this.addType.productType == 5 || this.addType.productType == 6) {
                    var storage = this.addStorageSmartphone[0] + 'GB '
                    var details = {
                        brand: this.addBrand,
                        model: this.addModel,
                        screen: this.addScreen.toString(),
                        processor: this.addProcessor,
                        ram: this.addRam.toString(),
                        storage: storage,
                        mainCamera: this.mainCamera,
                        frontCamera: this.frontCamera,
                        battery : this.addBattery,
                        feature : this.AddFeature
                    }
                    
                    for (var i = 0; i < this.addDuration.length; i++) {
                        this.duration.push({
                            tenorMonths: this.durationValue[i],
                            price: this.durationPrice[i],
                            depositPrice: this.depositPrice[i],
                            insurancePrice: this.insurancePrice[i],
                            condition:this.conditionProduct[i].status
                        })
                    }
                    this.$http.post(process.env.ADD_PRODUCT, {
                            productType: this.addType.productType,
                            productCategory: this.addCategory.productCategory,
                            details: details,
                            description: this.addDescription !== null ? this.addDescription.replace(this.spaceRegex, ' ') : this.addDescription,
                            photo: this.addPhoto,
                            duration: this.duration,
                            adminId: this.adminId,
                            status: x
                        }, {
                            timeout: 30 * 1000,
                            headers: {
                                'Asani-Token': localStorage.getItem('jwt')
                            }
                        })
                        .then(response => {
                            if (response.data.status == 400) {
                                swal("Sorry", response.data.message, "error", {
                                    button: "Ok",
                                })
                            } else if (response.data.status == 200) {
                                swal("Success", response.data.message, "success", {
                                    button: "Ok",
                                })
                                if (x == 'publish') {
                                    $('#modalSavePublish').modal('hide')
                                } else {
                                    $('#modalSaveDraft').modal('hide')
                                }
                                this.sendLog(response.data.content)
                                this.toProductCatalogPage()
                                this.loadingButtonProcess = false
                            }else if (response.data.status == 201) {
                                swal("Failed", response.data.message, "error", {
                                    button: "Close",
                                })
                                if (x == 'publish') {
                                    $('#modalSavePublish').modal('hide')
                                } else {
                                    $('#modalSaveDraft').modal('hide')
                                }
                                this.duration=[]
                                this.loadingButtonProcess = false
                            }
                        })
                        .catch(error => {
                            alert('Request timeout / error with api, please try again!')
                            self.loadingButtonProcess = false
                            swal("Sorry", error.response.data.message, "error", {
                                button: "Ok",
                            }).then(v => {
                                if(error.response.data.status == 401) {
                                    this.handleLogout()
                                }
                            })
                        })
                }else {
                    var details={}
                    if (this.addType.productType < 7){
                        details = {
                            brand: this.addBrand,
                            model: this.addModel,
                            screen: this.addScreen.toString()
                        }
                    }else{
                        details = {
                            brand: this.addBrand,
                            model: this.addModel,
                            specifications: this.addSpecifications
                        }
                    }
                    
                    for (var i = 0; i < this.addDuration.length; i++) {
                        this.duration.push({
                            tenorMonths: this.durationValue[i],
                            depositPrice:this.depositPrice[i],
                            price: this.durationPrice[i],
                            insurancePrice: this.insurancePrice[i],
                            condition:this.conditionProduct[i].status
                        })
                    }
                    this.$http.post(process.env.ADD_PRODUCT, {
                            productType: this.addType.productType,
                            productCategory: this.addCategory.productCategory,
                            details: details,
                            description: this.addDescription !== null ? this.addDescription.replace(this.spaceRegex, ' ') : this.addDescription,
                            photo: this.addPhoto,
                            duration: this.duration,
                            adminId: this.adminId,
                            status: x
                        }, {
                            timeout: 30 * 1000,
                            headers: {
                                'Asani-Token': localStorage.getItem('jwt')
                            }
                        })
                        .then(response => {
                            if (response.data.status == 400) {
                                swal("Sorry", response.data.message, "error", {
                                    button: "Ok",
                                })
                            } else if (response.data.status == 200) {
                                swal("Success", response.data.message, "success", {
                                    button: "Ok",
                                })
                                if (x == 'publish') {
                                    $('#modalSavePublish').modal('hide')
                                } else {
                                    $('#modalSaveDraft').modal('hide')
                                }
                                this.sendLog(response.data.content)
                                this.toProductCatalogPage()
                                this.loadingButtonProcess = false
                            }else if (response.data.status == 201) {
                                swal("Failed", response.data.message, "error", {
                                    button: "Close",
                                })
                                if (x == 'publish') {
                                    $('#modalSavePublish').modal('hide')
                                } else {
                                    $('#modalSaveDraft').modal('hide')
                                }
                                this.duration=[]
                                this.loadingButtonProcess = false
                            }
                        })
                        .catch(error => {
                            alert('Request timeout / error with api, please try again!')
                            self.loadingButtonProcess = false
                            swal("Sorry", error.response.data.message, "error", {
                                button: "Ok",
                            }).then(v => {
                                if(error.response.data.status == 401) {
                                    this.handleLogout()
                                }
                            })
                        })
                }
            },
            openModal(x) {
                $("#modal" + x).modal('show')
            },
            toPage(e) {
                this.$router.push(e)
            },
            async handleLogout() {
      try {
        const response = await this.$http.post(process.env.LOGOUT, {}, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        if (response.data.status !== 200) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          })
          return
        }

      } catch (error) {
        if(error.response.data.status != 401) {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          })
          return
        }
      }
                localStorage.removeItem('jwt')
                localStorage.removeItem('admin_name')
                localStorage.removeItem('roles')
                localStorage.removeItem('user_email')
                localStorage.removeItem('admin_id')
                localStorage.removeItem('changeCatalogPermission')
                this.$router.push('/')
            },
            cekLogin() {
                if (localStorage.getItem('jwt') == null) {
                    this.$router.push('/')
                }
            },
            cekPermission() {
                this.permission = localStorage.getItem('roles').replace(/"/g, "").replace("[", "").replace("]", "").split(",")
                for (var i = 0; i < this.permission.length; i++) {
                    if (this.permission[i] == "1") {
                        this.viewDashboard = true
                    }
                    if (this.permission[i] == "2.1") {
                        this.viewOrder = true
                    }
                    if (this.permission[i] == "2.2") {
                        this.editOrder = true
                    }
                    if (this.permission[i] == '3.1') {
                        this.viewReturn = true
                    }
                    if (this.permission[i] == '3.2') {
                        this.editReturn = true
                    }
                    if (this.permission[i] == '4.1') {
                        this.viewProduct = true
                    }
                    if (this.permission[i] == '4.2') {
                        this.editProduct = true
                    }
                    if (this.permission[i] == '5.1') {
                        this.viewPairing = true
                    }
                    if (this.permission[i] == '5.2') {
                        this.editPairing = true
                    }
                    if (this.permission[i] == '6') {
                        this.viewReconcile = true
                    }
                    if (this.permission[i] == '7.1') {
                        this.viewResolution = true
                    }
                    if (this.permission[i] == '7.2') {
                        this.editResolution = true
                    }
                    if (this.permission[i] == '8.1') {
                        this.viewLessor = true
                    }
                    if (this.permission[i] == '8.2') {
                        this.editLessor = true
                    }
                    if (this.permission[i] == '9.1') {
                        this.viewLessee = true
                    }
                    if (this.permission[i] == '9.2') {
                        this.editLessee = true
                    }
                    if (this.permission[i] == '10') {
                        this.viewEmployee = true
                    }
                }
                if (this.editProduct == false) {
                    this.$router.push('/')
                }
            },
            sidebar() {
                $("#wrapper").toggleClass("toggled");
            },
            removeImage(index) {
                this.addPhoto[index - 1] = {
                    imgFileName: '',
                    imgBase64: ''
                }
                document.getElementById("file_img_" + index).value = "";
                document.getElementById("show_img_" + index).src = 'https://asani-imagestorage.s3-ap-southeast-1.amazonaws.com/logo_upload+product/template_product.jpg';
            },
            onFilePicked(e, index) {
                const files = e.target.files
                if (files[0] !== undefined) {
                    this.imgFileName = files[0].name
                    if (this.imgFileName.lastIndexOf('.') <= 0) {
                        return
                    }
                    const fr = new FileReader()
                    fr.readAsDataURL(files[0])
                    fr.addEventListener('load', () => {
                        this.imgUrl = fr.result
                        this.imgFile = files[0] // this is an image file that can be sent to server...
                        this.imgBase64 = fr.result.split("base64,")[1]
                        if (this.imgFileName.toLowerCase().includes(".png")) {
                            if (this.imgFile.size >= 2000000) {
                                this.imgFileName = ''
                                this.imgFile = ''
                                this.imgUrl = ''
                                swal("Ukuran file tidak boleh lebih dari 2MB", "", "warning", {
                                        buttons: {
                                            agree: "OK",
                                        },
                                    })
                                    .then((value) => {
                                        // this.pickFile()
                                    });
                            } else {
                                var fuData = document.getElementById('file_img_' + index);
                                var FileUploadPath = fuData.value;
                                var reader = new FileReader();
                                reader.onload = function(e) {
                                    $('#show_img_' + index).attr('src', e.target.result);
                                }
                                reader.readAsDataURL(fuData.files[0]);
                                this.addPhoto[index - 1] = {
                                    imgFileName: this.imgFileName,
                                    imgBase64: this.imgBase64
                                }
                            }
                        } else {
                            alert("Photo only allows file types of PNG. ");
                            document.getElementById("file_img_" + index).value = "";
                            document.getElementById("show_img_" + index).src = 'https://asani-imagestorage.s3-ap-southeast-1.amazonaws.com/logo_upload+product/template_product.jpg';
                        }
                    })
                } else {
                    this.imgFileName = ''
                    this.imgFile = ''
                    this.imgUrl = ''
                }
            },
            isNumber: function(evt) {
                evt = (evt) ? evt : window.event;
                var charCode = (evt.which) ? evt.which : evt.keyCode;
                if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                    evt.preventDefault();;
                } else {
                    return true;
                }
            },
            getData() {
                this.pageAction = this.$route.params.pageAction.charAt(0).toUpperCase() + this.$route.params.pageAction.slice(1)
                this.loadingTable = true
                this.$http.get(process.env.GET_CATEGORY_ADD, {
                        headers: {
                            'Asani-Token': localStorage.getItem('jwt')
                        }
                    })
                    .then(response => {
                        if (response.data.status == 400) {
                            swal("Sorry", response.data.message, "error", {
                                button: "Ok",
                            })
                            // this.handleLogout()
                        } else {
                            this.productType = response.data.content.productType
                            this.productCategory = response.data.content.productCategory
                            this.productCategory.push({
                                productCategory: 'Other'
                            })

                            this.productBrand = Object.values(response.data.content.productBrand)
                            for (var i = 0; i < response.data.content.productDuration.length; i++) {
                                this.productDuration[0].push(response.data.content.productDuration[i])
                                this.temp.push(response.data.content.productDuration[i])
                            }
                            
                            this.productBrand.push('Other')
                            this.temp.push('Other')
                            this.productDuration[0].push('Other')
                        }
                    })
                    .catch(error => {
                        swal("Sorry", error.response.data.message, "error", {
                            button: "Ok",
                        }).then(v => {
                            if(error.response.data.status == 401) {
                                this.handleLogout()
                            }
                        })
                    })
            },
            sendLog(x){
                var today = new Date();
                var month = today.getMonth()+1
                if (month < 10) {
                    month = '0'+month
                }
                var dateDay = today.getDate()
                if (dateDay < 10) {
                    dateDay = '0'+dateDay
                }
                var hours = today.getHours()
                if (hours < 10) {
                    hours = '0'+hours
                }
                var minutes = today.getMinutes()
                if (minutes < 10) {
                    minutes = '0'+minutes
                }
                var second = today.getSeconds()
                if (second < 10) {
                    second = '0'+second
                }
                var date = today.getFullYear()+'-'+month+'-'+dateDay;
                var time = hours + ":" + minutes + ":" + second;
                var dateTime = date+' '+time;
                var admin = this.admin
                var command = 'add-logs'
                let productName = ''
                if (this.addBrand == 'Other') {
                    productName  = this.newBrand+' '+this.addModel
                }else{
                    productName  = this.addBrand+' '+this.addModel
                }
                this.$http.post(process.env.LOG_URL+"/product/"+x,{
                    codeLogs: 28,
                    params: [productName.replace(this.spaceRegex, ' ')],
                },{
                    headers: {'Asani-Token':localStorage.getItem('jwt')}
                })
                .then(response => {
                })
                .catch(error => {
                    console.log(error)
                })
            }
    },
    created() {
        for (var i = 0; i < 6; i++) {
            this.addPhoto.push({
                imgFileName: '',
                imgBase64: ''
            })
        }
        this.getData()
        this.admin = localStorage.getItem('admin_name')
        this.adminId = localStorage.getItem('admin_id')
        this.cekLogin()
        this.cekPermission()
    }
} 
</script>

    <!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .field-label{
        width: 188px;
    }
    .field-label.battery{
        width: 180px;
    }
    .field-label.display-size{
        width: 180px;
    }
    .field-label.new-tenor{
        width: 194px;
    }
    .field-label.select{
        width: 188px;
    }
    .field-label.ram{
        width: 178px;
    }
    .field-label.select{
        width: 184px;
    }
    .field-label.storage{
        width: 280px;
    }
    .field-label.storage-ssd{
        width: 177px;
    }
    .field-label-one{
        width: 164px;
    }
    .field-label-one.rp{
        width: 163px;
    }
    .field-label-one.select{
        width: 158px;
    }
    .duration{
        width: 240px;
        margin-left: 5px;
    }
    .duration-new{
        width: 165px;
        margin-left: 5px;
    }

    .input-group-addon {
        padding: 7px 12px;
        font-size: 14px;
        font-weight: 400;
        line-height: 1;
        color: #555;
        text-align: center;
        background-color: #eee;
        border: 1px solid #ccc;
        border-radius: 4px 0px 0px 4px;
        border-right: none;
        margin: 0px 0px 0px 10px;
        height: fit-content;
    }

    .img-responsive{
        width: 257px;
        height: auto;
    }
</style>


// WEBPACK FOOTER //
// src/components/Product/ProductAddBundlingPage.vue